var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M8.14726 21.9439L17.2382 13.1694C17.5151 12.8937 17.5314 12.4568 17.2871 12.1622L17.2382 12.1087L8.14767 3.05826C8.11019 3.02095 8.05945 3 8.00656 3L6.4432 3C6.33274 3 6.2432 3.08954 6.2432 3.2C6.2432 3.25319 6.26439 3.30419 6.30208 3.34173L15.61 12.6092L6.31172 21.6567C6.23255 21.7337 6.23082 21.8603 6.30785 21.9395C6.3455 21.9782 6.3972 22 6.45119 22L8.00837 22C8.06018 22 8.10998 21.9799 8.14726 21.9439Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.652e2df3b4a44f2811e2c5a8d5cf2a23.svg";
export { ForwardRef as ReactComponent };